import React from "react";
import { Signup } from "../../common/Signup/Signup";
import { Header } from "../../internal/Header/Header";
import useIfLoggedIn from "../../../hooks/useIfLoggedIn";
import labels from "../../../helpers/labels.json";
import { SignupwithGoogle } from "../../common/Signup/SignUpWithGoogle";
import { Helmet } from "react-helmet";
import styled from "styled-components";
import { Images } from "../../../assets/images";

const Index = ({ location = {}, isGoogleSignUp = false }) => {
  useIfLoggedIn();

  const inputs = [
    {
      name: "fullname",
      label: labels["onboarding.fullname"],
      type: "text",
      required: true,
    },
    {
      name: "email",
      label: labels["user.email"],
      type: "email",
      required: true,
    },
    {
      name: "mobile",
      label: labels["user.mobile"],
      type: "number",
      required: true,
    },
    {
      name: "password",
      label: labels["onboarding.password"],
      type: "password",
      required: true,
    },
  ];

  return (
    <>
      <Helmet>
        <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
        <title>Sign Up - IAMC</title>
        <meta
          name="description"
          content="IAMC Account Sign Up - Sign Up with Google account or using username, email, or phone number."
        />
        <meta
          name="keywords"
          content="Sign Up, IAMC, Resolve Disputes Online, Online Dispute Resolution, ODR Services, Alternative Dispute Resolution, ADR Services, Online Dispute Resolution in India"
        />
      </Helmet>

      <Header>
        <Container>
          <LeftPanel>
            <SignupContainer>
              {isGoogleSignUp ? (
                <SignupwithGoogle
                  heading={labels["onboarding.enter_phone_number"]}
                  inputs={inputs.filter(
                    (el) => el.label === labels["user.mobile"]
                  )}
                  tcLink="/terms-and-conditions"
                  loginLink="/login"
                  location={location}
                />
              ) : (
                <Signup
                  heading={labels["onboarding.step1"]}
                  inputs={inputs}
                  tcLink="/terms-and-conditions"
                  loginLink="/login"
                  location={location}
                />
              )}
            </SignupContainer>
          </LeftPanel>
          <RightPanel>
            <StyledImage src={Images.Login} alt="JustAct Signup Illustration" />
          </RightPanel>
        </Container>
      </Header>
    </>
  );
};

export default Index;

export const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  min-height: 100vh;
  max-width: 1400px;
  margin: 0 auto;
  width: 100%;

  @media (max-width: 1024px) {
    flex-direction: column;
  }
`;

export const LeftPanel = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 1024px) {
    padding: 2rem 1.5rem;
    order: 2;
  }

  @media (max-width: 768px) {
    padding: 1.5rem 1rem;
  }

  @media (max-width: 480px) {
    padding: 1rem 0.75rem;
  }

  @media (max-width: 360px) {
    padding: 0.75rem 0.5rem;
  }
`;

export const RightPanel = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;

  @media (max-width: 1024px) {
    height: 300px;
    order: 1;
    padding: 1rem;
  }

  @media (max-width: 768px) {
    height: 280px;
  }

  @media (max-width: 600px) {
    height: 240px;
  }

  @media (max-width: 480px) {
    height: 220px;
  }

  @media (max-width: 360px) {
    height: 200px;
  }
`;

const StyledImage = styled.img`
  width: 100%;
  height: auto;
  max-width: 600px;
  object-fit: contain;
  border-radius: 16px;

  @media (max-width: 1024px) {
    border-radius: 12px;
  }

  @media (max-width: 480px) {
    border-radius: 10px;
    max-width: 100%; 
  }
`;

export const SignupContainer = styled.div`
  background: #ffffff;
  border-radius: 20px;
  padding: 3.5rem 4rem;
  width: 100%;
  // max-width: 600px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.12);

  @media (max-width: 1024px) {
    max-width: 500px;
    padding: 3rem;
  }

  @media (max-width: 768px) {
    padding: 2rem;
    border-radius: 16px;
  }

  @media (max-width: 480px) {
    padding: 1.2rem;
    border-radius: 12px;
  }

  @media (max-width: 360px) {
    padding: 1rem;
    border-radius: 10px;
  }
`;
